<template>
  <a-card size="small" title="筛选条件" :bordered="false">
    <a-form-model class="search-form">
      <a-form-model-item>
        <a-row>
          <span style="margin-right: 8px">时间:</span>
          <a-range-picker v-model="checkedDate" :default-value="checkedDate" :allow-clear="false" @change="getTeamList" />
          <span style="margin-right: 8px; margin-left: 8px">报表列表:</span>
          <span>
            <a-select v-model="currentChartId" style="width: 180px" allow-clear @change="selectChart">
              <a-select-option v-for="chart in teams" :key="chart.id" :value="chart.id">{{ `工单报表第${chart.id}期` }} </a-select-option>
            </a-select>
          </span>
        </a-row>
      </a-form-model-item>
    </a-form-model>
  </a-card>
</template>

<script>
import moment from 'moment';
import { doGetChartList } from '@/api/data/ticket';
import { tagList } from '@/api/system/tag';

export default {
  name: 'DataFilter',
  props: {
    chartId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      checkedDate: [moment().subtract(1, 'month').add(1, 'day'), moment()],
      lastCheckedDate: [],
      labelCol: { span: 1 },
      wrapperCol: {},
      checkAll: true,
      indeterminate: false,
      currentChartId: this.chartId || null,
      plainOptions: [],
      teams: [],
      selectedTeams: []
    };
  },

  computed: {
    filter() {
      const { checkedDate, selectedTeams, lastCheckedDate, objective } = this;
      return {
        checkedDate,
        selectedTeams,
        lastCheckedDate,
        objective
      };
    }
  },

  watch: {
    filter() {
      this.$emit('change', this.checkedDate, this.lastCheckedDate);
    }
  },
  created() {
    this.getTeamList();
    this.$emit('change', this.checkedDate, this.lastCheckedDate);
  },

  methods: {
    filterModule(searchValue, treeNode) {
      return treeNode.data.props.title.includes(searchValue);
    },
    selectChart() {
      this.lastCheckedDate = [];
      // 在 teams 中查找选中的 chart 对象
      const selectedChart = this.teams.find(team => team.id == this.currentChartId);

      // 如果找到了对应的 chart 对象，则更新 lastCheckedDate
      if (selectedChart) {
        this.lastCheckedDate.push({
          startTime: selectedChart.startTime,
          endTime: selectedChart.endTime
        });
      }
    },
    // 获取团队列表
    getTeamList() {
      doGetChartList({ data_type: 'ticket', endTime: this.checkedDate[1], startTime: this.checkedDate[0] }).then(res => {
        this.teams = res.data;
        if (this.currentChartId != null) {
          this.selectChart();
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.ant-form-item {
  margin-bottom: 0px;
  border-bottom: silver 1px dashed;
}
</style>
